import React, { Component } from 'react'
import { Avatar, Input, Button } from 'antd';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { COLORS } from '../theme';
import { LockOutlined, PersonOutlineOutlined } from '@material-ui/icons';
import { withWhiteLabelContext } from 'react-whitelabel';


class LoginPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
        }

        this.get_setting = RESTExecutor.detail().config({
            label: 'bank_info'
        }).callbacks((success) => {
        }, (error) => {
        }).connect(props.domains.noAuth);

        this.get_setting.execute({
            force: true
        })

    }

    render() {
        let response = this
            .props
            .authenticator
            .response();
        let bank_response = this.get_setting.response();
        let bank_data = bank_response.result || {};
        const a="asd";
        console.log(a);

        let providedLabel = this.props.label || {};

        return (
            <div className='login-bg'>
                <div className='login-content-left'>

                    <img alt={providedLabel.p_name} className='login-logo' src={require('../../logo.png')} />
                    <span className='login-headling'>
                        Data Integration platform for extraction, processing and cataloging of big data
                    </span>
                </div>
                <div className='login-content-right'>
                    <div className='form-container'>
                        <span className='login-title'>Welcome to {providedLabel.p_name}.</span>
                        <span className='login-subtitle'>{providedLabel.p_name} is a platform for data extraction, processing and intelligence.</span>
                        <Input
                            className='input-username'
                            size='large'
                            prefix={< PersonOutlineOutlined type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder='username'
                            onChange={(e) => {
                                this.setState({ username: e.target.value })
                            }} />
                        <span className='error-text'> {response && response.error && response.validation_errors && response.validation_errors['username'] &&
                            Array.isArray(response.validation_errors['username']) && response.validation_errors['username'][0]}
                        </span>

                        <Input.Password
                            className='input-password'

                            size='large'
                            prefix={< LockOutlined type="key" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder='password'
                            onChange={(e) => {
                                this.setState({ password: e.target.value })
                            }}
                            onPressEnter={() => this.props.authenticator.login(this.state, (resp) => {
                                console.log("success login", resp);
                                let result = resp.result || {};
                                console.log("result is", result)
                                if (result.expired) {
                                    this.props.history.push({
                                        pathname: '/change-password',
                                        search: 'is_expired=true&is_first=true'
                                    }
                                    )
                                } else
                                    if (result.first_login) {
                                        this.props.history.push('/change-password?is_first=true')
                                    }

                            })} />
                        <span className='error-text'> {response && response.error && response.validation_errors && response.validation_errors['password'] &&
                            Array.isArray(response.validation_errors['password']) && response.validation_errors['password'][0]}
                        </span>

                        <div
                            style={{
                                color: COLORS.danger_primary,
                                marginBottom: 12,
                                marginTop: 12
                            }}>
                            {response && response.error && (typeof response.error_message === 'string'
                                ? response.error_message
                                : '')}
                        </div>
                        <Button
                            size='large'
                            loading={response && response.fetching}
                            type='primary'
                            style={{
                                borderColor: COLORS.primary,
                                backgroundColor: COLORS.primary,
                                // width: 200,
                                marginTop: 16,
                                marginBottom: 16
                            }}
                            onClick={() => {
                                this
                                    .props
                                    .authenticator
                                    .login(this.state, (resp) => {
                                        console.log("success login", resp);
                                        let result = resp.result || {};
                                        if (result.first_login) {
                                            this.props.history.push('/change-password?is_first=true')
                                        }
                                    })
                            }}>Login</Button>


                    </div>
                    <div style={{
                        color: COLORS.danger_primary,
                        marginBottom: 20,
                        fontSize: 14
                    }}>!!!WARNING!! This system belongs to <strong>{bank_data.name || providedLabel.c_name}</strong>.
                        Any Unauthorized access will be penalized to the maximum within the existing law. Access to this computer system and associated networks, computer, resources or data is restricted to business purposes authorized by the management of <strong>{bank_data.name || providedLabel.c_name}</strong>.
                        User activity is monitored and recorded by system personnel. Be advised, if possible unauthorized activity is detected, system records along with the relevant information may be provided to the law enforcement officials.
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <span className='footer-note'>{providedLabel.p_name} © 2023. Developed with ❤️
                            {/* <span>&nbsp;&nbsp;{providedLabel.d_name}</span> */}
                        </span>
                        <span className='support-text'>Contact Support</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default withWhiteLabelContext(withDomains(LoginPage, "adminAuth", "noAuth"))
